module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8532/img/footerCmsFree.png"